<script>
import { Bar, mixins } from "vue-chartjs";
import chartTooltipOptionMixin from "@/mixins/chartTooltipOptionMixin";
import NoDataChartLabelPlugin from "@/components/chart/plugins/nodata-label.plugin";
import { chartGlobalLabelDefaults } from "@/constants/chart-global-styles.constants";
const { reactiveProp } = mixins;

export default {
  name: "BarChartJs",
  extends: Bar,
  mixins: [reactiveProp, chartTooltipOptionMixin],
  props: ["chartOptions", "chartData"],
  computed: {
    options() {
      return _.merge(
        {
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  maxTicksLimit: 6,
                  beginAtZero: true,
                  callback: function(label, index, labels) {
                    if (label >= 1000) {
                      return label / 1000 + "k";
                    }
                    return label;
                  }
                }
              }
            ]
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          title: {
            fontFamily: `{chartGlobalLabelDefaults.styles.fontFamily`
          }
        },
        this.chartOptions
      );
    }
  },
  mounted() {
    this.$el.style.width = `${this.$el.parentElement.clientWidth}px`;
    this.$el.style.height = `${this.$el.parentElement.clientHeight}px`;

    this.addPlugin(NoDataChartLabelPlugin);
    this.renderChart(
      this.chartData,
      _.merge(this.options, {
        tooltips: this.customTooltipMixin
      })
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/components/chart/BarChartJs.vue